import * as SubscriptionBus from "./subscriptionBus"
import { useUserStore } from "@/stores/user"

export function isFreeAccount() {
	const userStore = useUserStore()
	return (userStore?.user?.subscription_type ?? "basic") === "basic"
}

export function showLockedModal(feature) {
	SubscriptionBus.showSubModal.value = true
	SubscriptionBus.subFeature.value = feature
}

export async function requestCheckSubscription(req, feature) {
	const userStore = useUserStore()
	// console.log(req.status)
	if (req.status === 403) {
		// console.log(userStore?.user.subscription_type)
		const request = req.clone()
		const data = await request.json()
		// console.log(data)
		if (data.subscription_type) {
			// userStore?.user?.value?.subscription_type = data.subscription_type
			// const user = userStore?.user
			// user.subscription_type = "basic" //data.subscription_type
			// userStore.setUser(user)
			userStore.user.subscription_type = data.subscription_type

			showLockedModal(feature)
		}
		return false
	}
	return true
}
